import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import formValueSelector from 'redux-form/es/formValueSelector';
import actions from 'redux-form/es/actions';
import Income from 'components/Credit24/LoanApplication/IncomeAU';
import { frequencyPeriods, incomeFrequency } from 'consts';
import { incomeAmountLimits } from '../../../consts/loan/AU';

const { change } = actions;

const propTypes = {
  change: PropTypes.func.isRequired,
  formIncomeFrequency: PropTypes.string,
  formIncomePayDayDate: PropTypes.string,
  hasGovernmentBenefits: PropTypes.bool,
};

const maxDateFromProps = (props) => {
  switch (props.formIncomeFrequency) {
    case frequencyPeriods.WEEKLY.type:
      return moment().add(1, 'week');
    case frequencyPeriods.FORTNIGHTLY.type:
      return moment().add(14, 'days');
    default:
      return moment().add(1, 'months');
  }
};

const getIncomeLimitsByFrequency = (frequency) => {
  const limit = incomeAmountLimits[frequency];
  return limit ? `$${limit.toLocaleString()}` : null;
};

class IncomeAUContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxDate: maxDateFromProps(props),
      minDate: moment(),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.formIncomeFrequency !== nextProps.formIncomeFrequency) {
      const maxDate = maxDateFromProps(nextProps);
      this.setState({ maxDate });
      if (moment(this.props.formIncomePayDayDate, 'YYYY-MM-DD').isAfter(maxDate)) {
        this.props.change('loan', 'incomePayDayDate', null);
      }
    }
  }

  render() {
    const incomeLimitValues = {
      limit: this.props.formIncomeFrequency
        ? getIncomeLimitsByFrequency(this.props.formIncomeFrequency).toLocaleString()
        : null,
    };
    return (
      <Income
        incomeFrequencies={incomeFrequency}
        minDate={this.state.minDate}
        maxDate={this.state.maxDate}
        calendarEnabled={!!this.props.formIncomeFrequency}
        hasGovernmentBenefits={this.props.hasGovernmentBenefits}
        incomeLimitValues={incomeLimitValues}
      />
    );
  }
}

IncomeAUContainer.propTypes = propTypes;

const selector = formValueSelector('loan');

export default connect(
  (state) => ({
    formIncomeFrequency: selector(state, 'incomeFrequency'),
    formIncomePayDayDate: selector(state, 'incomePayDayDate'),
    hasGovernmentBenefits: selector(state, 'governmentBenefits') === 'yes',
  }),
  { change }
)(IncomeAUContainer);
